<template>
  <WebsiteCmsShell
    class="website-service-page"
    :title="'Layanan Website ' + clinic_name"
    subtitle="Kelola layanan unggulan yang dapat ditemukan pasien di website klinik"
    action-label="Layanan Baru"
    list-eyebrow="Konten layanan"
    list-title="Daftar layanan"
    list-description="Atur informasi, urutan tampil, dan status setiap layanan."
    @action="$router.push('/website/service/add')"
  >
    <template #list><Table purpose="master" /></template>
  </WebsiteCmsShell>
</template>

<script>
import WebsiteCmsShell from "@/component/websites/WebsiteCmsShell.vue";
import Table from "@/component/websites/ServiceTable.vue";
import Form from "@/component/websites/ServiceForm.vue";
import FormEdit from "@/component/websites/ServiceFormEdit.vue";
import FormDetail from "@/component/websites/ServiceFormDetail.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "website-service",
  data() {
    return {
      form: {
        title: "",
        description: "",
        status: "",
        order: "",
        image: [],
      },
      FormEditActv: false,
      FormDetailActv: false,
      clinic_name : window.configuration == null ? "Medhop" :  window.configuration.clinic_name
    };
  },
  components: {
    WebsiteCmsShell,
    Table,
    Form,
    FormEdit,
    FormDetail,
  },
  methods: {
    resetFormOnNew() {
      // reset form on new (tambah data)
      var self = this;
      Object.keys(this.form).forEach(function (key, index) {
        if (key === "image") {
          self.form[key] = [];
        } else if(key === "_method"){
          self.form[key] = "post"
        } else {
          self.form[key] = "";
        }
      });
    },

    scrollToElement(options) {
      let el = this.$el.getElementsByClassName("website-cms-editor-anchor")[0];
      if (el) {
        el.scrollIntoView(options);
        // reset form on new (tambah data)
        this.resetFormOnNew();
      }
    },

    scrollToTop(options) {
      // window.scrollTo(0, 0);
      let el = this.$el;
      // el = el ?? this.$el.getElementsByClassName("table-setting")[0];
      if (el) {
        el.scrollIntoView(options);
        // reset form on new (tambah data)
        this.resetFormOnNew();
      }
    },

    btnAddOnClick() {
      this.FormEditActv = false;
      this.FormDetailActv = false;
      this.scrollToElement({ behavior: "smooth" });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Website", route: "" },
      { title: "CMS", route: "" },
      { title: "Layanan", route: "" },
    ]);

    // Add Website Service
    this.$root.$on("updateWebsiteService", () => {
      // reset form on new (tambah data)
      this.scrollToTop({ behavior: "smooth" });
      this.resetFormOnNew();
    });

    // Cancel Add Website Service
    this.$root.$on("cancelAddWebsiteService", () => {
      // reset form on new (tambah data)
      this.scrollToTop({ behavior: "smooth" });
      this.resetFormOnNew();
    });

    //  Edit Website Service
    this.$root.$on("getWebsiteServiceById", (data) => {
      this.FormDetailActv = false
      this.FormEditActv = true
     this.scrollToElement({ behavior: 'smooth' })

      if(data.status == 0){
        data.status = false
      }else if(data.status == 1){
        data.status = true
      }

     this.form = data
     this.form['_method'] = 'put'
    });

    // Cancel Edit
    this.$root.$on("cancelWebsiteServiceUpdate", () => {
      this.FormEditActv = false
      this.scrollToTop({ behavior: 'smooth' })
      this.resetFormOnNew()
    });

    // Detail Web Service
    this.$root.$on("getWebsiteServiceByIdDetail", (data) => {
      this.FormDetailActv = true
      this.FormEditActv = false
     this.scrollToElement({ behavior: 'smooth' })

      if(data.status == 0){
        data.status = false
      }else if(data.status == 1){
        data.status = true
      }
     this.form = data
    });

      // Close Detail
    this.$root.$on("closeWebsiteServiceDetail", () => {
      this.FormDetailActv = false
      this.scrollToTop({ behavior: 'smooth' })
      this.resetFormOnNew()
    });
  },
};
</script>
